import { render, staticRenderFns } from "./typeclass.vue?vue&type=template&id=9fbbd80e&scoped=true"
import script from "./typeclass.vue?vue&type=script&lang=js"
export * from "./typeclass.vue?vue&type=script&lang=js"
import style0 from "./typeclass.vue?vue&type=style&index=0&id=9fbbd80e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fbbd80e",
  null
  
)

export default component.exports